import * as Yup from 'yup';

export const searchValidateSchema = (t) =>
  Yup.object().shape({
    loading_address_radius: Yup.number()
      .transform((val) => (val === '' || isNaN(val) ? undefined : val))
      .min(1, t('errors.radiusMustBePositive')),
    unloading_address_radius: Yup.number()
      .transform((val) => (val === '' || isNaN(val) ? undefined : val))
      .min(1, t('errors.radiusMustBePositive')),
    weight_to: Yup.number()
      .transform((val) => (val === '' || isNaN(val) ? undefined : val))
      .when('weight_from', {
        is: (weight_from) => Number(weight_from),
        then: Yup.number()
          .transform((val) => (val === '' || isNaN(val) ? undefined : val))
          .min(Yup.ref('weight_from'), t('errors.incorrectRange')),
      }),
    volume_to: Yup.number()
      .transform((val) => (val === '' || isNaN(val) ? undefined : val))
      .when('volume_from', {
        is: (volume_from) => Number(volume_from),
        then: Yup.number()
          .transform((val) => (val === '' || isNaN(val) ? undefined : val))
          .min(Yup.ref('volume_from'), t('errors.incorrectRange')),
      }),
    length_to: Yup.number()
      .transform((val) => (val === '' || isNaN(val) ? undefined : val))
      .when('length_from', {
        is: (length_from) => Number(length_from),
        then: Yup.number()
          .transform((val) => (val === '' || isNaN(val) ? undefined : val))
          .min(Yup.ref('length_from'), t('errors.incorrectRange')),
      }),
    width_to: Yup.number()
      .transform((val) => (val === '' || isNaN(val) ? undefined : val))
      .when('width_from', {
        is: (width_from) => Number(width_from),
        then: Yup.number()
          .transform((val) => (val === '' || isNaN(val) ? undefined : val))
          .min(Yup.ref('width_from'), t('errors.incorrectRange')),
      }),
    height_to: Yup.number()
      .transform((val) => (val === '' || isNaN(val) ? undefined : val))
      .when('height_from', {
        is: (height_from) => Number(height_from),
        then: Yup.number()
          .transform((val) => (val === '' || isNaN(val) ? undefined : val))
          .min(Yup.ref('height_from'), t('errors.incorrectRange')),
      }),
  });
